<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Tree Report"  path="frontdash"/>
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                         <div class="card-header">
                                <div class="row">
                                  
                                    <div class="col-md-3 col-12 position-relative"  >
                                        <label class="form-label">User Nagarpalika</label>
                                        <select class="form-select" required="" v-model="filter.np"  @change="getAgents($event)">
                                            <option selected=""   disabled="" value="0">Choose...</option>
                                            <template v-for="(item ,index)  in nagarpalika_list" :key="item.id">
                                                  <option :value="item.id">{{item.name}}</option>   
                                            </template> 
                                        </select>
                                    </div>
                                    
                                     <div class="col-md-3 col-12 position-relative"  >
                                        <label class="form-label">Agents</label>
                                        <select class="form-select" required="" v-model="filter.agent">
                                            <option selected=""   disabled="" value="0">Choose...</option>
                                            <template v-for="(item ,index)  in filter_agent_list" :key="item.id">
                                                  <option :value="item.id">{{item.empname}} ({{item.empcode}})</option>   
                                            </template> 
                                        </select>
                                    </div>
                                    
                                    
                                    <div class="col-xl-3 col-md-3 col-12" >
                                        <label class="form-label"><span class="f-w-500 f-14">From Date</span></label>
                                        <input class="form-control" type="date" v-model="filter.fromdate" >
                                    </div>
                                     <div class="col-xl-3 col-md-3 col-12" >
                                        <label class="form-label"><span class="f-w-500 f-14">To Date</span></label>
                                        <input class="form-control" type="date" v-model="filter.todate" >
                                    </div>
                                     <div class="col-xl-3 col-sm-12 col-12" >
                                        <button class="btn btn-primary" @click="filterReport"><i class="fa fa-filter"></i> Filter</button> &nbsp;&nbsp;
                                        <button class="btn btn-success" @click="downloadImagesAsZip"><i class="fa fa-download"></i> Download</button>
                                        
                                    </div>
                                      <div class="col-xl-12 col-md-12 col-12" >
                                        <label class="form-label"><span class="f-w-500 f-14">Society Filter</span></label>
                                        <div class=" input-group">
                                            <input class="form-control" type="text" v-model="filter_society" >
                                            <span @click="search_sureyFilter" class="badge bg-success search_icon"><i class="fa fa-search"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p class="text-danger">{{loading}}</p>
                        <div class="card-body badge-spacing">
                                  <div class="gallery my-gallery card-body row" itemscope="">
                                    <figure v-for="(item ,index)  in treereports"  class="col-xl-2 col-md-3 col-4" itemprop="associatedMedia" itemscope="" style="height:150px;">
                                        <a :href="get_image_path(item)" itemprop="contentUrl" data-size="1600x950">
                                            <img class="img-thumbnail" :src="get_image_path(item)" itemprop="thumbnail"  :alt="item.local_name+'/'+item.comman_name+'/'+item.botnical_name+'/'+item.other_name">
                                        </a>
                                      <figcaption itemprop="caption description">{{item.id}} ) {{item.agent_name}}</figcaption>
                                    </figure>
                     
                             <!--<figure v-for="(item ,index)  in treereports"  class="grid-item col-xl-2 col-sm-3 col-6" itemprop="associatedMedia" itemscope="">-->
                             <!--    <a target="_blank" :href="get_image_path(item)" itemprop="contentUrl" data-size="">-->
                             <!--        <img class="img-thumbnail" :src="get_image_path(item)" itemprop="thumbnail" alt="Image description">-->
                             <!--     <div class="">-->
                             <!--       <h6>{{item.id}} ) {{item.agent_name}}</h6>-->
                             <!--      <p>{{item.local_name+'/'+item.comman_name+'/'+item.botnical_name+'/'+item.other_name}}</p>-->
                             <!--     </div></a>-->
                                
                             <!-- </figure>-->
                         
                                    
                                </div>
                                  <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
                    <div class="pswp__bg"></div>
                    <div class="pswp__scroll-wrap">
                      <div class="pswp__container">
                        <div class="pswp__item"></div>
                        <div class="pswp__item"></div>
                        <div class="pswp__item"></div>
                      </div>
                      <div class="pswp__ui pswp__ui--hidden">
                        <div class="pswp__top-bar">
                          <div class="pswp__counter"></div>
                          <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
                          <button class="pswp__button pswp__button--share" title="Share"></button>
                          <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
                          <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                          <div class="pswp__preloader">
                            <div class="pswp__preloader__icn">
                              <div class="pswp__preloader__cut">
                                <div class="pswp__preloader__donut"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                          <div class="pswp__share-tooltip"></div>
                        </div>
                        <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>
                        <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>
                        <div class="pswp__caption">
                          <div class="pswp__caption__center"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer   start-->
 
</template>
<style scopped>
    th{
            text-transform: capitalize;
    }
    .table th, .table td{
        padding: 0.4em !important;
    }
    .hide{
        display: none;
    }
    .search_icon{
            height: 29px;
    padding: 10px;
    }
</style>
<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue'; 
import axios from 'axios'; 
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

export default {
    name: 'TreeReport', 
    components: {
        PageTitle
    },
      
    mounted() {
         if (this.$route.query.q) {
                this.getBasics(1);
            }else {
               this.getBasics(0);
            }
        

    }, data() {
        return {
          filter_society:'',
          filter_agent_list: [],
          agent_list: [],
          nagarpalika_list: [],
          treereports: [],
          original_treereports: [],
          fromDate: '',
          toDate: '',
          loading:'',
          userDetails:{"emprole":0},
          datatable:null,
          filter:{'np':'','agent':'','fromdate':'','todate':''}
        }
    },
   
    methods: { 
        get_image_path(item){
            return this.$hostname+''+item.tree_image.replace("treeimages","treeimages_v2");
        },
        async downloadImagesAsZip() {
          // const imageUrls = Array.from(this.treereports).map(img => this.$hostname+''+img.tree_image);
    
          const zip = new JSZip();
    
          const fetchImage = async (url, index,row) => {
            try {
              const response = await fetch(url);
              if (!response.ok) throw new Error(`Failed to fetch ${url}`);
              const blob = await response.blob();
              const ext = url.split('.').pop(); // Get the file extension from URL
              zip.file(`${row.id}_${row.byuser}_${row.local_name}.${ext}`, blob);
            } catch (error) {
              console.error(`Error downloading ${url}:`, error);
            }
          };
    
          for (let i = 0; i < this.treereports.length; i++) {
              var tree_path=this.treereports[i].tree_image.replace("treeimages","treeimages_v2");
            await fetchImage( this.$hostname+''+tree_path, i,this.treereports[i]);
          }
    
          zip.generateAsync({ type: 'blob' }).then(content => {
            saveAs(content, 'images.zip');
          });
        },
        search_sureyFilter(){ 
             var self=this; 
             if(self.filter_society=='')
                self.treereports=self.original_treereports;
             else
                self.treereports=self.original_treereports.filter(item => item.society_name.toLowerCase().includes(self.filter_society.toLowerCase()));
        },
        getAgents(event){ 
             var np_id=event.target.value;
              this.filter_agent_list=this.agent_list.filter(item => item.empdept === np_id);
             
              
        },
        async filterReport() {
               var self = this; 
               self.loading="Please Wait.....";
                 axios.post('filterTreeSurveyReport', { filter: self.filter })
                    .then(function (response) {
                        
                        self.treereports = response.data.survey_report; 
                        self.original_treereports=self.treereports;
                        self.nagarpalika_list = response.data.nagarpalika_list; 
                    }).then(()=>{
                           if(!this.isScriptLoaded("//naturesurvey.in/assets/js/photoswipe/photoswipe.js")){
                                    const plugin2 = document.createElement("script");
                                    plugin2.setAttribute("src","//naturesurvey.in/assets/js/photoswipe/photoswipe.js");
                                    plugin2.async = true;
                                    document.body.appendChild(plugin2);  
                                    
                              }else{
                                  document.querySelector('script[src="//naturesurvey.in/assets/js/photoswipe/photoswipe.js"]').remove();
                                   const plugin2 = document.createElement("script");
                                    plugin2.setAttribute("src","//naturesurvey.in/assets/js/photoswipe/photoswipe.js");
                                    plugin2.async = true;
                                    document.body.appendChild(plugin2);  
                              }
                              self.loading="";
                    });
        },
       async getBasics(today) {
            var self = this;
            self.loading="Please Wait.....";
            axios.post('getTreeSurveyReport',{today:today}).then(function (response) {
                // self.treereports = response.data.survey_report; 
                self.userDetails = response.data.userDetails;   
                self.nagarpalika_list = response.data.nagarpalika_list; 
                self.agent_list = response.data.agent_list; 
                window.scrollTo(0, 0);
            }).then(()=>{
                self.loading="";
            });
        },
        
        
         isScriptLoaded(src)
          {
              return Boolean(document.querySelector('script[src="' + src + '"]'));
          },
        
        exportKML(){ 
                    var data = this.datatable.rows({ search: 'applied' }).data();
                    var kml = '<?xml version="1.0" encoding="UTF-8"?>\n' +
                              '<kml xmlns="http://www.opengis.net/kml/2.2">\n' +
                              '  <Document>\n';
    
                    data.each(function (value, index) {
                        var name = value[3]+'('+value[12]+')';
                       var latlng = value[8]+','+value[7];
                       // var lng = value[2];
    
              kml += '  	         <Placemark>\n'+
                     '      				<name>\n'+
                     '      					<![CDATA[Row: '+(1+index)+']]>\n'+
                     '      				</name>\n'+
                     "      				<Snippet maxLines='0'></Snippet>\n"+
                     '      				<styleUrl>#0_0</styleUrl>\n'+
                     '      				<ExtendedData></ExtendedData>\n'+
                     '      				<LookAt>\n'+
                     '      					<longitude>'+value[8]+'</longitude>\n'+
                     '      					<latitude>'+value[7]+'</latitude>\n'+
                     '      					<range>1000</range>\n'+
                     '      					<altitudeMode>relativeToGround</altitudeMode>\n'+
                     '      					<tilt>0</tilt>\n'+
                     '      					<heading>0</heading>\n'+
                     '      				</LookAt>\n'+
                     '      				<Point>\n'+
                     '      					<altitudeMode>clampToGround</altitudeMode>\n'+
                     '      					<extrude>0</extrude>\n'+
                     '      					<coordinates>'+latlng+',0</coordinates>\n'+
                     '      				</Point>\n'+
                     '      				<description>\n'+
                     "      					<![CDATA[<style type='text/css'>*{font-family:Verdana,Arial,Helvetica,Sans-Serif;box-sizing:border-box;padding:0px;margin:0px}table{border-collapse:collapse;border-spacing:0px;margin:2px}.trb{background-color:#ddffdd}.ch{vertical-align:top;padding-left:10px;white-space:nowrap}.cv{vertical-align:top;padding-left:6px;padding-right:10px;white-space:nowrap}.cw{vertical-align:top;padding-left:6px;padding-right:10px;width:600px}</style><table><tr class='trb'><td class='ch'><b>Entry Id</b></td><td class='cv'>"+value[19]+"</td></tr><tr><td class='ch'><b>Survey Date</b></td><td class='cv'>"+value[1]+"</td></tr><tr class='trb'><td class='ch'><b>Agent Name</b></td><td class='cv'>"+value[2]+"</td></tr><tr><td class='ch'><b>local_name</b></td><td class='cv'>"+value[3]+"</td></tr><tr class='trb'><td class='ch'><b>comman_name</b></td><td class='cv'>"+value[4]+"</td></tr><tr><td class='ch'><b>botnical_name</b></td><td class='cv'>"+value[5]+"</td></tr><tr class='trb'><td class='ch'><b>other_name</b></td><td class='cv'>"+value[6]+"</td></tr><tr><td class='ch'><b>Latitude</b></td><td class='cv'>"+value[7]+"</td></tr><tr class='trb'><td class='ch'><b>Longitude</b></td><td class='cv'>"+value[8]+"</td></tr><tr><td class='ch'><b>girth</b></td><td class='cv'>"+value[9]+"</td></tr><tr class='trb'><td class='ch'><b>height</b></td><td class='cv'>"+value[10]+"</td></tr><tr><td class='ch'><b>Conopy diameter</b></td><td class='cv'>"+value[11]+"</td></tr><tr class='trb'><td class='ch'><b>tree_condition</b></td><td class='cv'>"+value[12]+"</td></tr><tr><td class='ch'><b>tree_balance</b></td><td class='cv'>"+value[13]+"</td></tr><tr class='trb'><td class='ch'><b>remark</b></td><td class='cv'>"+value[14]+"</td></tr><tr><td class='ch'><b>ownership</b></td><td class='cv'>"+value[15]+"</td></tr><tr class='trb'><td class='ch'><b>society_name</b></td><td class='cv'>"+value[16]+"</td></tr><tr><td class='ch'><b>road_name</b></td><td class='cv'>"+value[17]+"</td></tr><tr class='trb'><td class='ch'><b>bird_nest</b></td><td class='cv'>"+value[18]+"</td></tr><tr><td class='ch'><b>ID</b></td><td class='cv'>"+value[19]+"</td></tr></table>]]>\n"+
                     
                     '      				</description>\n'+
                     '      			</Placemark> \n';
                    });
    
                    kml += '  </Document>\n' +
                           '</kml>';
    
                    var blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'data.kml';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
        },
          exportKMLNew(){ 
                    var data = this.datatable.rows({ search: 'applied' }).data();
                    var kml = '<?xml version="1.0" encoding="UTF-8"?>\n' +
                              '<kml xmlns="http://www.opengis.net/kml/2.2">\n' +
                              '  <Document>\n'+
                              '<name>Trees in Solapur</name>\n'+
                              '<description>Locations of 10 trees in Solapur city</description>\n';
    
                    data.each(function (value, index) {
                        var name = value[3]+'('+value[12]+')';
                        var latlng = value[7]+','+value[8];
                       // var lng = value[2];
    
                        kml += '    <Placemark>\n' +
                               '      <name>' + name + '</name>\n' + 
                               '      <Point>\n' +
                               '        <coordinates>' + latlng + ',0</coordinates>\n' +
                               '      </Point>\n' +
                               '    </Placemark>\n';
                    });
    
                    kml += '  </Document>\n' +
                           '</kml>';
    
                    var blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'data.kml';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
        }
         
    }
}
</script>
